import $ = require('jquery');

import {SiteadminController} from "SiteadminController";

import ShowroomApplier from 'diy/site-admin/showroom/ShowroomApplier';
import ShowroomDesignInfo from 'diy/site-admin/showroom/ShowroomDesignInfo';

let api = require<any>('../api');

const SCREEN_PERCENTAGE = 0.9;
const MIN_SIZE = {
    width: 600,
    height: 400
};
const SITEADMIN_WIDTH = 90;

class SiteAdminShowroom implements SiteadminController {

    private controllerLoaded = false;
    private showroomApplier: ShowroomApplier;
    private showroomDesignInfo: ShowroomDesignInfo;

    afterFillContent(el: HTMLElement, response: any, contentElement: JQuery) {

        this.showroomApplier = new ShowroomApplier();
        this.showroomDesignInfo = new ShowroomDesignInfo();

        if (response.data.settings.features.hasOwnProperty('ownlayout')
            && response.data.settings.features.ownlayout === true) {
            let tabs = [{
                title: response.data.settings.labels.showroom,
                identifier: 'showroom',
                url: '/app/siteadmin/showroom/index/',
                contentType: 'inline',
                windowBehavior: {
                    cacheWindow: false,
                    header: {small: true},
                    footer: false
                },
                callback: () => {
                    api.updateHelpTopic('');
                    this.highlightTab('showroom');
                },
                attrs: {
                    params: 'showroom'
                }
            },
            {
                title: response.data.settings.labels.ownlayout,
                identifier: 'ownlayout',
                url: '/app/siteadmin/layoutselector/api/',
                contentType: 'iframe-local',
                windowBehavior: {
                    cacheWindow: false,
                    header: {small: true},
                },
                callback: () => {
                    this.highlightTab('ownlayout');
                },
                attrs: {
                    params: 'showroom'
                }
            }
            ];
            api.updateNavi(tabs);
            this.highlightTab('showroom');
            this.showroomDesignInfo.show(document.getElementsByClassName('sa-window')[0] as HTMLElement);
        } else {
            api.hideNavi();
        }

        this.controllerLoaded = true;
    };

    allowSwitch() {
        return this.controllerLoaded;
    };

    show() {
        //this function is required by the interface however we do not have any use for it here.
        if (this.showroomDesignInfo) {
            this.showroomDesignInfo.show(document.getElementsByClassName('sa-window')[0] as HTMLElement);
        }
    };

    hide() {
        //this function is required by the interface however we do not have any use for it here.
        this.showroomDesignInfo.hide();
    };
    getWindowSize() {
        return {
            width: Math.max(
                SCREEN_PERCENTAGE * (document.documentElement.clientWidth) - SITEADMIN_WIDTH,
                MIN_SIZE.width
            ),
            height: Math.max(SCREEN_PERCENTAGE * document.documentElement.clientHeight, MIN_SIZE.height)
        };
    };

    applySelection(selectionId: string, url: string) {

        this.showroomApplier.show(selectionId, url);

    };

    private highlightTab = function(id: string) {
        let navi = $('div.cc-sa-controller-showroom header nav');
        navi.find('li').removeClass('ui-tabs-selected ui-state-active');
        navi.find('a').removeClass('active');

        navi.find('li a[data-identifier="' + id + '"]').parent().addClass('ui-tabs-selected ui-state-active');
        navi.find('li a[data-identifier="' + id + '"]').addClass('active');
    };
}

let controllerInstance = new SiteAdminShowroom();
export = controllerInstance;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/main/controllers/showroom.ts
 **/